import { TreeToolbar } from "slot-definitions"
import { Button, Divider, Tooltip } from "@mui/material"
import { useComparisonSchedule } from "routes/schedule/edit/useComparisonSchedule"
import { CommitChange, DraftReason, UndoRedoChange } from "event-definitions"
import { IsEditMode } from "lib/@components/edit-mode"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { delay } from "lib/delay"
import { isSame } from "library/normalized-stringify/index.mjs"
import { useDialog } from "lib/@hooks/useDialog"
import { AuditModal } from "routes/regime/components/audit-modal"
import { generate } from "library/guid/index.mjs"

export function PublishButton() {
    UndoRedoChange.useRefresh()
    const { target, immediateSave, editRefresh, saveStatus } = useBoundContext()
    const [compare] = useComparisonSchedule() ?? []

    const isOffline = saveStatus === "queued"
    const noChanges = isSame(compare, target, skipProps)

    const reasonsForDraft = useDialog(
        <AuditModal placeholder="Tell the reviewer what changes you have made and why..." />
    )
    return (
        <IsEditMode>
            <>
                <Tooltip title={isOffline ? "You are offline. Reconnect to submit for review." : ""}>
                    <span>
                        <Button
                            size="small"
                            disabled={noChanges || isOffline}
                            variant="contained"
                            color="primary"
                            onClick={publish}
                            data-cy="publish-button"
                        >
                            Submit for Review
                        </Button>
                    </span>
                </Tooltip>
                <Divider orientation="vertical" flexItem />
            </>
        </IsEditMode>
    )

    async function publish() {
        const audit = await reasonsForDraft()
        if (!audit) return
        target.groupReviewId = generate()
        DraftReason.raise(audit.revisionSummary)
        CommitChange.raise()
        await delay(50)
        target.behaviours.state = "review"
        immediateSave()
        editRefresh()
    }

    function skipProps(key) {
        return key.startsWith("search_")
    }
}

TreeToolbar.plug(<PublishButton priority={2} if={({ target }) => target.behaviours?.state === "default"} />)
